import { MODAL_OPENED_EVENT } from 'amplitude/events'

export const toggleDialog = (dialogRef, log) => () => {
  log && log()

  return dialogRef?.current?.isOpen
    ? dialogRef?.current?.close?.()
    : dialogRef?.current?.open?.()
}

export const logModalOpened = (log, eventName, dialogRef) =>
  !dialogRef?.current?.isOpen
    ? () => log(MODAL_OPENED_EVENT, { Name: eventName })
    : null
